export const MAX_FILE_SIZE_BYTES = 500 * 1024 * 1024; // 500 MB

export const ALLOWED_FILE_EXTENSIONS = ['csv', 'xlsx', 'xls', 'json'] as const;
export const ACCEPT_ATTR = ALLOWED_FILE_EXTENSIONS.map((e) => `.${e}`).join(',');
